import React, { lazy, Suspense, useState, useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
//import process.env from '../config.json';
import axios from 'axios';
import swal from 'sweetalert';
import $, { data } from 'jquery';
import moment from 'moment';
import Dropzone from 'react-dropzone-uploader';
import 'react-dropzone-uploader/dist/styles.css'
import Select, { components } from 'react-select';
import removeImg from './icons/remove.svg'

import country_arr from './common_arr/countries-arr.js';
import s_a from './common_arr/states-arr.js';

import { Modal } from "react-bootstrap";
import uuid from 'react-uuid';
import { Link, Redirect } from 'react-router-dom';
import product_unit_arr from './common_arr/product-unit-arr.js';

import { setCookie, getCookie } from '../common_component/cookie.js';
import Organization_modal from '../common_component/organization_modal.js';
import Timer_modal from '../common_component/timer_modal.js';

function DealerSaleEntry(props) {
    const timer_interval_ref = useRef();
    const [clockTimerModalShow, setClockTimerModalShow] = useState(false);
    const [state_org, setstate_org] = useState(2);
    const [organization_name, setOrganization_name] = useState("");
    const [user_name, setuser_name] = useState("");
    const [user_type, setuser_type] = useState("");
    const [OrganizationModalShow, setOrganizationModalShow] = useState(false);
    const [redirect_to_login, setRedirect_to_login] = useState(2);

    const [user_id, setuser_id] = useState("")

    const [user, setUser] = useState({});
    const [state, setstate] = useState(2);
    const [state1, setstate1] = useState(3);
    const timer = useRef(0)
    //const [timer, setTimer] = useState(0);
    const [clock_timer, setClockTimer] = useState(0);

    const [orderNumber, setOrderNumber] = useState("")
    const [invoiceNumber, setInvoiceNumber] = useState("")
    const [isdName, setISDName] = useState("")
    const [orderDate, setOrderDate] = useState(moment().format('YYYY-MM-DD'));
    const [ItemApiState, setItemApiState] = useState(false);

    const [fileNames, setFileNames] = useState([])
    const [fileSessionUniqueId, setFileSessionUniqueId] = useState(uuid());

    const [billingAddressFlag, setBillingAddressFlag] = useState(true)
    const [LegalName, setLegalName] = useState("");
    const [TradeName, setTradeName] = useState("");
    const [GstIN, setGstIN] = useState("");

    const [customerType, setCustomerType] = useState("business")
    const [primaryContact, setPrimaryContact] = useState({ salutation: null, firstName: "", lastName: "" })
    const [companyName, setCompanyName] = useState("")
    const [customerDisplayNameOptions, setCustomerDisplayNameOptions] = useState([])
    const [selectedCustomerDisplayName, setSelectedCustomerDisplayName] = useState(null)
    const [customerMobileNumber, setCustomerMobileNumber] = useState(null)
    const [workPhone, setWorkPhone] = useState("");
    const [mobile, setMobile] = useState("")
    const [designation, setDesignation] = useState("")
    const [department, setDepartment] = useState("")
    const [email, setEmail] = useState("")
    const [website, setWebsite] = useState("")
    const [selectedLeadSource, setSelectedLeadSource] = useState(null)

    const [SupplyStateOptions, setSupplyStateOptions] = useState([]);
    const [placeSupply, setPlaceSupply] = useState(null);
    const [gstTreatmentlist, setgstTreatmentlist] = useState([{ label: "Registered Business-Regular", value: "Registered Business-Regular", description: "A business that is registered under GST" }, { label: "Unregistered Business", value: "Unregistered Business", description: "Business that has not been registered under GST" }])
    const [gstTreatment, setGstTreatment] = useState({ label: "Unregistered Business", value: "Unregistered Business", description: "Business that has not been registered under GST" })

    const [billingCountryOptions, setBillingCountryOptions] = useState([]);
    const [billingStateOptions, setBillingStateOptions] = useState([]);
    const [billingSelectedCountry, setBillingSelectedCountry] = useState({ label: "India", value: "India" })
    const [billingSelectedState, setBillingSelectedState] = useState({ label: "West Bengal", value: "West Bengal" })
    const [billingCity, setBillingCity] = useState("");
    const [billingPincode, setBillingPincode] = useState("");
    const [Shipping_flag, setShipping_flag] = useState(false);

    const [selectedBillingAddress, setSelectedBillingAddress] = useState([]);
    const [selectedShippingAddress, setSelectedShippingAddress] = useState([]);
    const [SerialName, setSerialName] = useState("");
    const [Currency_symbol, setCurrency_symbol] = useState("");
    const [Currency_code, setCurrency_code] = useState("");
    const [Currency_id, setCurrency_id] = useState("");
    const [decimal_place, setdecimal_place] = useState("");

    const [selectedCustomer, setSelectedCustomer] = useState(null);
    const [selectedCustomerEmail, setSelectedCustomerEmail] = useState(null);
    const [customerList, setCustomerList] = useState([]);
    const [taxGroupList, setTaxGroupList] = useState([]);
    const [customerApiState, setCustomerApiState] = useState(false);

    const [menuBlockScroll, setmenuBlockScroll] = useState(false);
    const [ItemModalShow, setItemModalShow] = useState(false);
    const [SerialModalShow, setSerialModalShow] = useState(false);
    const [itemarrindex, setItemArrIndex] = useState(0);
    const [CustomerModalShow, setCustomerModalShow] = useState(false);
    const [Product_type, setProduct_type] = useState("Goods");
    const [ItemName, setItemName] = useState("");
    const [UnitSelectionList, setUnitSelectionList] = useState([]);
    const [Unit, setUnit] = useState("8");
    const [TaxSelectionList, setTaxSelectionList] = useState([{ label: "Taxable", value: "Taxable" }, { label: "Non Taxable", value: "Non Taxable" }, { label: "Out of Scope", value: "Out of Scope" }, { label: "Non-GST Supply", value: "Non-GST Supply" }]);
    const [TaxPreference, setTaxPreference] = useState("Taxable");
    const [TaxCalculationMethod, setTaxCalculationMethod] = useState("TAX_Inclusive")
    const [Default_tax_preference, setDefault_tax_preference] = useState({ "Inter_State_Tax": "", "Intra_State_Tax": "" });
    const [Tracking_inventory, setTracking_inventory] = useState(false);
    const [Tracking_inventory_type, setTracking_inventory_type] = useState("");
    const [itemSubmitButtonState, setitemSubmitButtonState] = useState(false);
    const [customerSubmitButtonState, setCustomerSubmitButtonState] = useState(false);
    const [brand, setBrand] = useState(null);

    const [selectedDealer, setSelectedDealer] = useState([]);
    const [selectedBrand, setSelectedBrand] = useState([]);
    const [DealerApiState, setDealerApiState] = useState(false);
    const [dealerList, setdealerList] = useState([]);
    const [brandList, setBrandList] = useState([]);
    const [brandListAPIState, setBrandListAPIState] = useState(false);
    const [itemList, setItemList] = useState([]);
    const [itemListAPIState, setItemListAPIState] = useState(false);
    const [itemArray, setItemArray] = useState([{ product_id: "", product_name: "", quantity: 1, serial_number_list: [], mop_price: 0, selling_price: 0 }])

    const [visibility, setvisibility] = useState(0);
    const [redirect, setredirect] = useState(0);
    const [read, setread] = useState(2);
    const [write, setwrite] = useState(2);
    const [userTheme, setUserTheme] = useState((localStorage.getItem("kt_metronic_theme_mode_menu") == "system") ? window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light" : localStorage.getItem("kt_metronic_theme_mode_menu"));

    const [deptName, setDeptName] = useState("");
    const [Department_code, setDepartment_code] = useState("");
    const [Department_head, setDepartment_head] = useState("");
    const [deptDesc, setDeptDesc] = useState("");
    const [userlist, setuserList] = useState([])
    const [editmodal, setEditModal] = useState([]);

    const [distributorOrganizationID, setDistributorOrganizationID] = useState("");
    const [organization_id, setOrganization_id] = useState("");
    const [organization_list, setorganization_list] = useState([]);
    const [mainSubmitButtonState, setMainSubmitButtonState] = useState(false);

    let search_length = 2;

    var page_name = "isd-sale-entry";

    const loaderstyle = {
        display: "block",
        marginLeft: "auto",
        marginRight: "auto",
        marginTop: "auto",
        marginBottom: "auto",
    };

    let dropdownStyleDark = {
        option: (provided, state) => ({
            ...provided,
            color: '#dddddf',
            backgroundColor: state.isSelected ? provided.backgroundColor : state.isFocused ? '#5f5f8d' : provided.backgroundColor,
        }),
        control: (provided, state) => ({
            ...provided,
            backgroundColor: "#2b2b40",
            borderColor: "#4c4c71"
        }),
        placeholder: (provided, state) => ({
            ...provided,
            color: "#dddddf",
        }),
        singleValue: (provided, state) => ({
            ...provided,
            color: "#dddddf",
        }),
        menu: (provided, state) => ({
            ...provided,
            backgroundColor: "#2b2b40",
        })
    }

    useEffect(() => {
        if (getCookie("access_token") != "") {
            if (getCookie("organization_id") != "") {
                setOrganization_id(getCookie("organization_id"));
            }
            else {
                var object = {};
                object.page_name = page_name;
                var headers = {
                    headers: {
                        "Content-Type": "application/json",
                        "token": getCookie("access_token"),
                        "Accept": "*/*"
                    }
                }

                axios.post(`${process.env.REACT_APP_SERVER_URL}/show-organization`, object, headers).then((res) => {
                    if (res.data.length == 1) {
                        setCookie('organization_id', res.data[0].organization_id, 1, true);
                        setOrganization_id(res.data[0].organization_id)
                    }
                    else {
                        setstate_org(1);
                        setorganization_list(res.data);
                        setOrganizationModalShow(true);
                    }
                })
            }
        }
        else {
            setRedirect_to_login(1);
        }
    }, [])

    useEffect(() => {
        let id = setInterval(() => {
            setUserTheme((localStorage.getItem("kt_metronic_theme_mode_menu") == "system") ? window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light" : localStorage.getItem("kt_metronic_theme_mode_menu"))
        }, 10)

        return () => {
            clearInterval(id)
        }
    }, [])

    useEffect(() => {
        setCookie("lastpage", window.location.href, 1, false)
        const validateJWT = () => {

            if (getCookie("access_token") != "") {
                var object = {};
                object.token = getCookie("access_token");

                var headers = {
                    headers: {
                        "Content-Type": "application/json",
                        "Accept": "*/*"
                    }
                }
                axios.post(`${process.env.REACT_APP_SERVER_URL}/get-user`, object, headers).then((res) => {

                    if (res.data.operation == "success") {
                        var user_object = {};
                        user_object.email = res.data.email;
                        user_object.name = res.data.name;
                        user_object.img = res.data.img;
                        setUser(user_object)
                    }
                    else {
                        swal("Session Expired!", "Please login to continue using.", "warning").then((value) => {
                            window.location.href = "/login"
                        });
                    }
                })
                    .catch(function (error) {
                        swal("Session Expired!", "Please login to continue using.", "warning").then((value) => {
                            window.location.href = "/login"
                        });
                    });
                object.organization_id = organization_id;
                axios.post(`${process.env.REACT_APP_SERVER_URL}/audience-info`, object, headers).then((res) => {
                    if (res.data.operation == "success") {
                        var token = res.data.audience_license;
                        if (res.data.organization_flag == 0) {
                            setstate_org(3);
                            setOrganization_name(res.data.organization_name);
                            setOrganizationModalShow(true);
                        }
                        else {
                            setuser_id(res.data.user_type.id);
                            setuser_name(res.data.user_type.name);
                            setuser_type(res.data.user_type.type);
                            setDistributorOrganizationID(res.data.user_type.organization_id);

                            var path = window.location.pathname;
                            path = path.replace(/\/$/, "");
                            path = decodeURIComponent(path);
                            var original_url = path.split("/")[1]

                            let index = 0;
                            let temp = -1;
                            for (let i = 0; i < res.data.user_access.access.length; i++) {
                                if (temp == 1) break;
                                let component = res.data.user_access.access[i].inside_components;
                                for (let j = 0; j < component.length; j++) {
                                    if (component[j].hasOwnProperty(original_url)) {
                                        index = i;
                                        if (res.data.user_access.access[index].inside_components[j][original_url] == 1 && res.data.user_access.access[index].visibility == 1) {
                                            temp = 1;
                                            setvisibility(1);
                                            setread(res.data.user_access.access[index].inside_components[j]["read"])
                                            setwrite(res.data.user_access.access[index].inside_components[j]["write"])
                                            // setwrite(0)
                                            break;
                                        }
                                        else {
                                            setredirect(1);
                                        }
                                    }
                                    else if (component[j].hasOwnProperty("key")) {
                                        let sub_inside_components = component[j].inside_components
                                        for (let k = 0; k < sub_inside_components.length; k++) {
                                            if (sub_inside_components[k].hasOwnProperty(original_url)) {
                                                index = i
                                                if (sub_inside_components[k][original_url] == 1 && res.data.user_access.access[index].visibility == 1 && component[j].visibility == 1) {
                                                    temp = 1;
                                                    setvisibility(1);
                                                    setread(sub_inside_components[k]["read"])
                                                    setwrite(sub_inside_components[k]["write"])
                                                    // setwrite(0)
                                                    break;

                                                }
                                                else {
                                                    setredirect(1);
                                                }
                                            }
                                        }
                                    }
                                    else {
                                        temp = 2;
                                    }
                                }
                            }

                            if (temp == 2) {
                                setredirect(1);
                            }
                        }

                        if (!token.includes("ufhdsupw29fher") || !token.includes("pdbwu27dh6schs") || !token.includes("0dh27agiqbcrwi")) {
                            setCookie('access_token', res.data.audience_license, 1, true)
                            timer.current = process.env.REACT_APP_JWT_EXPIRY
                            //setClockTimer(process.env.REACT_APP_JWT_EXPIRY);
                        }
                        else {
                            timer.current = res.data.audience_count
                        }
                    }
                    else {
                        setRedirect_to_login(1);
                    }
                })
                    .catch(function (error) {
                        console.log(error);
                        setRedirect_to_login(1);
                    });
            }
            else {
                setRedirect_to_login(1);
            }
        }

        organization_id != "" && validateJWT();

    }, [organization_id])

    useEffect(() => {
        timer_interval_ref.current = setInterval(() => {
            // console.log(timer)

            timer.current = timer.current - 1
            if (timer.current > 0 && timer.current < process.env.REACT_APP_JWT_EXPIRY_NOTICE) {
                if (!clockTimerModalShow) {
                    setClockTimer(process.env.REACT_APP_JWT_EXPIRY_NOTICE)
                    setClockTimerModalShow(true)
                }
            }
        }, 1000);

        return () => { clearInterval(timer_interval_ref) };
    }, []);

    useEffect(() => {
        setSelectedCustomerDisplayName(null)
        let tempArr = []
        if (primaryContact.salutation != null) {
            if (primaryContact.firstName.trim() != "") {
                if (primaryContact.lastName.trim() != "") {
                    tempArr.push(primaryContact.salutation.value + " " + primaryContact.firstName + " " + primaryContact.lastName, primaryContact.firstName + " " + primaryContact.lastName, primaryContact.lastName + ", " + primaryContact.firstName)
                }
                else {
                    tempArr.push(primaryContact.salutation.value + " " + primaryContact.firstName, primaryContact.firstName)
                }
            }
            else {
                if (primaryContact.lastName.trim() != "") {
                    tempArr.push(primaryContact.salutation.value + " " + primaryContact.lastName, primaryContact.lastName)
                }
            }
        }
        else {
            if (primaryContact.firstName.trim() != "") {
                if (primaryContact.lastName.trim() != "") {
                    tempArr.push(primaryContact.firstName + " " + primaryContact.lastName, primaryContact.lastName + ", " + primaryContact.firstName)
                }
                else {
                    tempArr.push(primaryContact.firstName)
                }
            }
            else {
                if (primaryContact.lastName.trim() != "") {
                    tempArr.push(primaryContact.lastName)
                }
            }
        }
        setCustomerDisplayNameOptions(tempArr)
    }, [primaryContact])

    useEffect(() => {
        let obj_array = []
        country_arr.country_arr.forEach((obj, index) => {
            if (index != 0) {
                let obj2 = {};
                obj2.label = obj;
                obj2.value = obj;

                obj_array.push(obj2);
            }
        })
        setBillingCountryOptions(obj_array);
    }, []);

    useEffect(() => {
        var obj_array = [];
        var Productunitarr = product_unit_arr.product_unit_arr;
        for (let k = 0; k < Productunitarr.length; k++) {
            var obj2 = {};
            obj2.label = Productunitarr[k].Short_term + "(" + Productunitarr[k].Unit + ")";
            obj2.value = Productunitarr[k].id;
            obj_array.push(obj2);
        }
        setUnitSelectionList(obj_array);
    }, [])

    useEffect(() => {
        if (billingCountryOptions.length > 0) {
            let selectedCountryIndex = 0;
            billingCountryOptions.map((obj, index) => {
                //console.log(obj.value);
                if (obj.value == "India") {
                    selectedCountryIndex = index;
                }
            })
            // console.log(selectedCountryIndex)

            let state_arr = s_a.s_a[selectedCountryIndex + 1].split("|");
            let obj_array = [];
            for (let i = 0; i < state_arr.length; i++) {
                obj_array.push({ value: state_arr[i], label: state_arr[i] });
            }
            setSupplyStateOptions(obj_array);
            setBillingStateOptions(obj_array);
        }

    }, [billingCountryOptions]);

    function loadBillingStateOptions(country) {
        let selectedCountryIndex = 0;
        billingCountryOptions.map((obj, index) => {
            if (obj.value == country.value) {
                selectedCountryIndex = index;
            }
        })
        //console.log(selectedCountryIndex)

        let state_arr = s_a.s_a[selectedCountryIndex + 1].split("|");
        let obj_array = [];
        for (let i = 0; i < state_arr.length; i++) {
            obj_array.push({ value: state_arr[i], label: state_arr[i] });
        }
        setBillingStateOptions(obj_array);
    }

    async function getTaxGroupDetails() {
        var object = {};
        object.email = user.email;

        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/tax-group-datatable`, { method: 'POST', body: JSON.stringify({ "email": user.email, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();
        // console.log(body.data)

        if ((body.operation == "success") && (body.data.length > 0)) {
            setTaxGroupList(body.data);
        }
    }

    async function getBrands(val) {
        setBrandListAPIState(true)
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/get-brands-by-search`, { method: 'POST', body: JSON.stringify({ search_value: val, "email": user.email, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();
        setBrandList(body.data.list);
        setBrandListAPIState(false);
        setstate(1);
    }

    async function getBrandsProduct(val, item, index) {
        setstate1(2);
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/get-brand-wise-product`, { method: 'POST', body: JSON.stringify({ ids: val, "email": user.email, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();
        if (item !== "") {
            const arr = [...itemArray];
            let new_item = body.data.list.filter(option => option.product_name === item);
            arr[index].product_id = new_item[0].pid
            arr[index].product_name = new_item[0].product_name;
            setItemArray(arr);
        }
        setItemList(body.data.list);
        setItemListAPIState(false);
        setstate1(1);
    }

    async function getDealers() {
        setDealerApiState(true);
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/get-isd-connected-dealer`, { method: 'POST', body: JSON.stringify({ "email": user.email, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();
        // console.log(body)

        if (body.operation === "success") {
            setdealerList(body.data);
            // if(props.match.params.id!=undefined)
            // {
            //     let temp=body.data.filter(obj => obj.cid ==props.match.params.id)[0];
            //     setSelectedDealer([{ label:temp.dealer_display_name, value:temp.cid }])
            // }
            setDealerApiState(false);
        }
        else {
            throw "dealer list api error"
        }
    }

    async function getCustomers(flag) {
        setCustomerApiState(true);
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/get-customer-by-search`, { method: 'POST', body: JSON.stringify({ "email": user.email, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();
        // console.log(body)

        if (body.operation === "success") {
            setCustomerList(body.data.list);
            if (body.data.list.length > 0) {
                //getCustomerDetails(body.data.list[0].cid)
                if (flag) {
                    setSelectedCustomer({ label: body.data.list[0].customer_display_name + " - " + body.data.list[0].email, value: body.data.list[0].cid });
                    getCustomerDetails(body.data.list[0].cid);
                }
            }
            setCustomerApiState(false);
        }
        else {
            throw "customer list api error"
        }
    }

    async function getCustomerDetails(val) {
        setCustomerApiState(true);
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/get-customer-details`, { method: 'POST', body: JSON.stringify({ "email": user.email, "id": val, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();
        // console.log(body)

        if (body.operation === "success") {
            if (body.data.length > 0) {
                setCustomerMobileNumber(body.data[0].phone);
                setSelectedBillingAddress(body.data[0].billing_address);
                setSelectedShippingAddress(body.data[0].shipping_address);
            }
            setCustomerApiState(false);
        }
        else {
            throw "customer list api error"
        }
    }

    async function getItems(search_value) {
        setItemApiState(true);
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/get-product-by-search`, { method: 'POST', body: JSON.stringify({ "email": user.email, "search_value": search_value, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();
        // console.log(body)
        if (body.operation === "success") {
            setItemList(body.data.list);
            setItemApiState(false);
        }
    }

    async function getSalePrefixDetails() {
        setstate1(2);
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/get-dealer-isd-sale-prefix-details`, { method: 'POST', body: JSON.stringify({ "email": user.email, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();
        setOrderNumber(body.document_number);
    }

    async function getbasecurrency() {
        var object = {};
        object.email = user.email;

        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/get-base-currency`, { method: 'POST', body: JSON.stringify({ "email": user.email, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();

        if (body.length > 0) {
            setCurrency_symbol(body[0].currency_symbol);
            setCurrency_code(body[0].currency_code);
            setdecimal_place(body[0].decimal_place);
            setCurrency_id(body[0].currency_id);
        }
    }

    async function getTaxGroupDetails() {
        var object = {};
        object.email = user.email;

        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/tax-group-datatable`, { method: 'POST', body: JSON.stringify({ "email": user.email, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();
        // console.log(body.data)

        if ((body.operation == "success") && (body.data.length > 0)) {
            setTaxGroupList(body.data);
        }
    }

    useEffect(() => {
        if ((read || write) && (user.email && visibility)) {
            let p2 = getBrands()
            let p1 = getDealers()
            let p3 = getCustomers(false)
            let p4 = getSalePrefixDetails()
            let p5 = getbasecurrency()
            let p6 = getTaxGroupDetails()
            Promise.all([p1, p2, p3, p4, p5, p6])
                .then(() => {
                    //setstate1(1)
                    console.log("all apis done")
                })
                .catch((err) => {
                    setstate(0)
                    console.log(err)
                })
        }

    }, [user, visibility, read, write])

    const trimDecimalPlaces = (amt, decimal_place) => {
        return Math.round(amt * Math.pow(10, decimal_place)) / Math.pow(10, decimal_place)
    }


    const submitSaleDetails = (e) => {
        e.preventDefault();
        var object = {};
        //object.organization_id = organization_id;
        e.preventDefault();
        var object = {};

        object.distributor_organization_id = distributorOrganizationID
        object.Payment_for = "ISD"
        object.payment_user_name = user_name
        object.payment_user_id = user_id
        object.selectedBrand = selectedBrand
        object.itemArray = itemArray
        object.orderDate = orderDate
        object.dealerList = selectedDealer
        object.selectedBillingAddress = selectedBillingAddress
        object.selectedShippingAddress = selectedShippingAddress
        object.Currency_code = Currency_code
        object.decimal_place = decimal_place
        object.Currency_id = Currency_id
        object.Currency_symbol = Currency_symbol
        object.orderNumber = orderNumber
        object.invoiceNumber = invoiceNumber
        object.selectedCustomer = selectedCustomer
        object.customerMobileNumber = customerMobileNumber
        object.fileNames = fileNames
        object.unique_id = fileSessionUniqueId;
        object.organization_id = organization_id;
        object.page_name = page_name;

        ///Global validation
        if (selectedBrand.length == 0) {
            swal("Oops!", "Atleast one brand need to be select", "warning");
            return false
        }
        if (invoiceNumber == "") {
            swal("Warning!", "Please enter a Invoice Number", "warning");
            return false
        }
        if (selectedDealer.length == 0) {
            swal("Oops!", "Atleast one Dealer need to be select", "warning");
            return false
        }

        ///item part validation
        let t = itemArray.find(o => {
            if (o.product_id == "" && o.product_name == "") {
                return o
            }
        })
        if (t != undefined) {
            swal("Oops!", "Sale item cannot be empty", "warning");
            return false
        }

        let t1 = itemArray.find(o => {
            if (Number(o.quantity) < o.serial_number_list.length) {
                return o
            }
        })
        if (t1 != undefined) {
            swal("Oops!", "Serial Number count can't be greater than item quantity.", "warning");
            return false
        }
        let t2 = itemArray.find(o => {
            if ((Number(o.selling_price) < 1)) {
                return o
            }
        })
        if (t2 != undefined) {
            swal("Oops!", "Selling price should be greater than zero.", "warning");
            return false
        }

        if (selectedCustomer == null) {
            swal("Warning!", "Please select a customer.", "warning");
            return false
        }

        // console.log(object)

        setMainSubmitButtonState(true)
        var headers = {
            headers: {
                "Content-Type": "application/json",
                "Accept": "*/*",
                "token": getCookie("access_token")
            }
        }

        axios.post(`${process.env.REACT_APP_SERVER_URL}/add-dealer-isd-sale`, object, headers).then((res) => {
            setMainSubmitButtonState(false)
            if (res.data && res.data.operation == "success") {
                swal("Great!", "Sale Details added successfully!", "success").then((value) => {
                    window.location.href = "/sale-list";
                });
            }
            else if (res.data.message === "duplicate_invoice") {
                swal("Oops!", "Same Invoice already exist!!", "error");
            }
            else {
                swal("Oops!", "Something went wrong!", "error");
            }
        }).catch(function (error) {
            console.log(error)
        });
    }

    const handleChangeStatus2 = ({ meta }, status, allFiles) => {
        const { name } = meta;

        if (status === 'done') {
            setMainSubmitButtonState(false)
            setFileNames([...fileNames, name])
        }
        else if (status === 'removed') {
            setMainSubmitButtonState(false)
            let temp = [...fileNames]
            temp.splice(temp.indexOf(name), 1)
            setFileNames(temp)
        }
        else if (status === "error_file_size") {
            allFiles[0].remove()
            swal("Oops!", "File size exceeded", "warning");
        }
    };

    const getUploadParams2 = ({ file }) => {

        const body = new FormData();
        body.append('dataFiles', file);
        body.append('unique_id', fileSessionUniqueId);
        body.append('organization_id', organization_id);
        body.append('user_id', user.email);
        body.append('page_name', page_name);

        let headers = {
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': 'Origin, X-Requested-With, Content-Type, Accept',
            "token": getCookie("access_token")
        }

        setMainSubmitButtonState(true)
        return { url: `${process.env.REACT_APP_SERVER_URL}/upload-dealer-isd-sale-documents`, headers, body }
    }

    const icon = {
        remove: { backgroundImage: `url(${removeImg})` },
    }

    const Preview = ({ fileWithMeta: { remove }, meta }) => {
        const { name, percent, status, previewUrl } = meta;
        // console.log(name)
        return (

            <div className="preview-box">
                <img src={previewUrl} style={{ maxHeight: "80px", maxWidth: "80px", borderRadius: "4px", marginRight: "10px" }} />
                <span title={name} className="name">{name.length >= 10 ? name.slice(0, 10) + "...." : name}</span> - <span className="status">{(status === "done") ? "Successfully Uploaded" : status}</span>{status !== "done" && <span className="percent"> ({Math.round(percent)}%)</span> && <span className="dzu-previewButton remove" onClick={remove} >
                    <svg version="1.1" width="16" height="16" viewBox="0 0 122.88 122.88">
                        <g>
                            <path className="st0" d="M1.63,97.99l36.55-36.55L1.63,24.89c-2.17-2.17-2.17-5.73,0-7.9L16.99,1.63c2.17-2.17,5.73-2.17,7.9,0 l36.55,36.55L97.99,1.63c2.17-2.17,5.73-2.17,7.9,0l15.36,15.36c2.17,2.17,2.17,5.73,0,7.9L84.7,61.44l36.55,36.55 c2.17,2.17,2.17,5.73,0,7.9l-15.36,15.36c-2.17,2.17-5.73,2.17-7.9,0L61.44,84.7l-36.55,36.55c-2.17,2.17-5.73,2.17-7.9,0 L1.63,105.89C-0.54,103.72-0.54,100.16,1.63,97.99L1.63,97.99z" />
                        </g>
                    </svg>
                </span>}
                {
                    status === "done" &&
                    <span className="dzu-previewButton remove" onClick={remove} >
                        <svg version="1.1" width="16" height="16" viewBox="0 0 122.88 122.88">
                            <g>
                                <path className="st0" d="M1.63,97.99l36.55-36.55L1.63,24.89c-2.17-2.17-2.17-5.73,0-7.9L16.99,1.63c2.17-2.17,5.73-2.17,7.9,0 l36.55,36.55L97.99,1.63c2.17-2.17,5.73-2.17,7.9,0l15.36,15.36c2.17,2.17,2.17,5.73,0,7.9L84.7,61.44l36.55,36.55 c2.17,2.17,2.17,5.73,0,7.9l-15.36,15.36c-2.17,2.17-5.73,2.17-7.9,0L61.44,84.7l-36.55,36.55c-2.17,2.17-5.73,2.17-7.9,0 L1.63,105.89C-0.54,103.72-0.54,100.16,1.63,97.99L1.63,97.99z" />
                            </g>
                        </svg>
                    </span>
                }
            </div>
        )
    }

    const submitItemDetails = () => {

        console.log(brand)

        if (ItemName.length == 0) {
            swal("Warning!", "Please enter a Item Name", "warning");
            return false;
        }
        if (Unit.length == 0) {
            swal("Warning!", "Please select a unit", "warning");
            return false;
        }
        if (brand === null) {
            swal("Warning!", "Please select a brand", "warning");
            return false;
        }

        var values = {
            "ItemName": ItemName,
            "Unit": Unit,
            "Sku": "",
            "Product_type": Product_type,
            "Manufacturer": "",
            "Brand": brand.value,
            "SubCategory": "",
            "Category": "",
            "Hsn_code": "",
            "Sac_code": "",
            "Tracking_inventory": Tracking_inventory,
            "Tracking_inventory_type": Tracking_inventory_type,
            "Shipping_flag": 0,
            "Shipping_info": JSON.stringify([{ "Weight": "", "Dimension": { "Width": "", "Height": "", "Length": "" } }]),
            "Specification_info": JSON.stringify({ "MPN": "", "ICBN": "", "UPC": "", "EAN": "" }),
            "TaxPreference": TaxPreference,
            "Tax_Calculation_Method": TaxCalculationMethod,
            "Default_tax_preference": JSON.stringify(Default_tax_preference),
            "organization_id": organization_id,
            "page_name": page_name,
        };

        let brand_arr = [...selectedBrand];
        if (selectedBrand.filter(option => option.value === brand.value).length === 0) {
            brand_arr.push(brand)
        }
        setSelectedBrand(brand_arr);

        setitemSubmitButtonState(true);
        var headers = {
            headers: {
                "Content-Type": "application/json",
                "Accept": "*/*",
                "token": getCookie("access_token")
            }
        }

        axios.post(`${process.env.REACT_APP_SERVER_URL}/product`, values, headers).then((res) => {
            setitemSubmitButtonState(false)
            if (res.data && res.data.operation == "success") {
                swal("Great!", "Item details saved successfully!", "success").then((value) => {
                    getBrandsProduct(brand_arr.map((object) => object.value), ItemName, itemarrindex);
                    setItemModalShow(false);
                    setItemName("");
                    setBrand(null);
                });
            }
            else {
                swal("Oops!", "Something went wrong!", "error");
            }
        });
    }

    const handleNewCustomerModalClose = () => {
        setCustomerModalShow(false);
        setPrimaryContact({ salutation: null, firstName: "", lastName: "" });
        setSelectedCustomerDisplayName(null);
        setWorkPhone("");
        setEmail("");
        setPlaceSupply(null);
        setGstIN("");
        setLegalName("");
        setTradeName("");
        setBillingSelectedCountry({ label: "India", value: "India" });
        setBillingSelectedState({ label: "West Bengal", value: "West Bengal" });
        setBillingCity("");
        setBillingPincode("");
        setShipping_flag(false)
        setGstTreatment({ label: "Unregistered Business", value: "Unregistered Business", description: "Business that has not been registered under GST" });
    }

    const submitCustomerDetails = () => {
        var nexp = /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~0-9]/;
        if ((primaryContact.firstName == "") && (primaryContact.lastName == "")) {
            swal("Warning!", "Primary Contact must contain first name or last name", "warning");
            return
        }

        if (selectedCustomerDisplayName == null) {
            swal("Warning!", "Customer Display Name cannot be empty", "warning");
            return
        }

        if (workPhone == "") {
            swal("Warning!", "Work phone cannot be empty", "warning");
            return
        }
        let regex1 = /^(\+\d{1,3}[- ]?)?\d{10}$/
        if (!regex1.test(workPhone)) {
            swal("Warning!", "Please provide valid Work phone number", "warning");
            return
        }


        if (email == "") {
            swal("Warning!", "Email id cannot be empty", "warning");
            return false;
        }
        let regex2 = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
        if ((email != "") && (!regex2.test(email))) {
            swal("Warning!", "Please enter a valid Email id", "warning");
            return false;
        }

        if (gstTreatment === null) {
            swal("Warning!", "GST Treatment cannot be empty", "warning");
            return
        }
        if (placeSupply === null) {
            swal("Warning!", "Supply Place cannot be empty", "warning");
            return
        }
        if (gstTreatment !== null && (gstTreatment !== "Consumer" && gstTreatment !== "Unregistered Business")) {
            if (GstIN === null) {
                swal("Warning!", "GSTIN cannot be empty", "warning");
                return
            }
            if (LegalName === null) {
                swal("Warning!", "Business Legal Name cannot be empty", "warning");
                return
            }
        }

        let object = {};

        let billing_arr = [];
        let billing_country = (billingSelectedCountry == null) ? null : billingSelectedCountry.value
        let billing_state = (billingSelectedState == null) ? null : billingSelectedState.value

        if (billingCity === "" && billing_country === null && billing_state === null && billingPincode === "") {
            object.billingAddressFlag = false;
        }
        else if (billingCity === "" || billing_country === null || billing_state === null || billingPincode === "") {
            if (billingCity === "") {
                billing_arr.push("City");
            }
            if (billing_country === null) {
                billing_arr.push("Country");
            }
            if (billing_state === null) {
                billing_arr.push("State");
            }
            if (billingPincode === "") {
                billing_arr.push("PinCode");
            }
        }
        else if (billingCity !== "" && billing_country !== null && billing_state !== null && billingPincode !== "") {
            object.billingAddressFlag = true;
        }
        if (billing_arr.length > 0) {
            setBillingAddressFlag(true);
            swal("Warning!", billing_arr.toString() + " field can't be empty.", "warning");
            return
        }

        object.gstTreatment = gstTreatment.value;
        object.placeSupply = placeSupply.value;

        object.gst_details = {};

        object.gst_details.GstIN = GstIN;
        object.gst_details.LegalName = LegalName;
        object.gst_details.TradeName = TradeName;

        object.customer_type = customerType
        object.primary_contact = { ...primaryContact, salutation: primaryContact.salutation == null ? null : primaryContact.salutation.value }
        object.customer_display_name = selectedCustomerDisplayName.value
        object.work_phone = workPhone
        object.email = email
        object.lead_source = "CRM"

        object.Shipping_flag = Shipping_flag
        object.currency = { currency_code: Currency_code, currency_id: Currency_id }
        object.address_details = {};

        object.address_details.country = (billingSelectedCountry == null) ? null : billingSelectedCountry.value
        object.address_details.state = (billingSelectedState == null) ? null : billingSelectedState.value
        object.address_details.city = billingCity
        object.address_details.pincode = billingPincode

        //object.profile_photo = profilePhoto
        object.file_names = fileNames
        object.unique_id = fileSessionUniqueId

        object.organization_id = organization_id;
        object.page_name = page_name;

        // console.log(object)
        setCustomerSubmitButtonState(true)

        var headers = {
            headers: {
                "Content-Type": "application/json",
                "Accept": "*/*",
                "token": getCookie("access_token")
            }
        }

        axios.post(`${process.env.REACT_APP_SERVER_URL}/customers`, object, headers).then((res) => {
            setCustomerSubmitButtonState(false)
            if (res.data.operation === "same_email") {
                swal("Oops!", "Email already exists!!", "error");
            }
            else if (res.data.operation === "same_name") {
                swal("Oops!", "Customer name already exists!!", "error");
            }
            else if (res.data.operation === "success") {
                swal("Great!", "You have added the Customer successfully!", "success").then((value) => {
                    setSelectedCustomer({ label: selectedCustomerDisplayName.label + " - " + email, value: res.data.id });
                    getCustomers(true);
                    handleNewCustomerModalClose();
                });
            }
            else {
                swal("Oops!", "Something went wrong!", "error");
            }
        })
            .catch(function (error) {
                console.log(error)
            });
    }

    const Add_serial = (index) => {
        const item_arr = [...itemArray];
        if (SerialName != "") {
            var Duplicate = item_arr[index].serial_number_list.find(s => s == SerialName);
            //var Duplicate1 = available_serial_number.find(s => s.serialName == SerialName);

            if ((typeof (Duplicate) !== "undefined" && JSON.stringify(Duplicate).length > 0)) {
                swal("Warning!", "This Serial Number already exist.Try different one.", "warning").then((value) => {
                    setSerialName("");
                });
            }
            else {
                if (Number(item_arr[index].quantity) > item_arr[index].serial_number_list.length) {
                    item_arr[index].serial_number_list.push(SerialName);
                    setSerialName("");
                }
                else {
                    swal("Warning!", "Serial Number count can't be greater than item quantity.", "warning").then((value) => {
                        setSerialName("");
                    });
                }
            }
        }
        else {
            swal("Warning!", "Serial Number can't be blank.", "warning").then((value) => {
                setSerialName("");
            });
        }
        setItemArray(item_arr);
    }

    const Remove_serial = (index) => {
        const arr = [...itemArray];
        arr[itemarrindex].serial_number_list.splice(index, 1);
        setItemArray(arr);
    }


    return (
        <>
            {
                (redirect == 1 || (read == 0 && write == 0)) ?
                    <>
                        <Redirect to={{
                            pathname: "/unauthorized",
                        }}
                        />
                    </> :
                    null
            }

            <div className="d-flex flex-column flex-column-fluid">
                <div className="app-toolbar py-3 py-lg-6" id="kt_app_toolbar">
                    <div id="kt_app_toolbar_container" className="app-container container-xxl d-flex flex-stack">
                        <h1 className="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0">ISD Sale Entry

                            <small className="text-muted fs-7 fw-bold my-1 ms-1"></small>
                        </h1>
                    </div>
                </div>
                <div id="kt_app_content" className="app-content flex-column-fluid">
                    <div id="kt_app_content_container" className="app-container container-xxl">
                        {state == 1 ?
                            <>
                                <div className="card">
                                    <div className="card-body border-top p-9">
                                        <div className=" py-10 px-lg-17">
                                            <div className="scroll-y me-n7 pe-7" id="kt_modal_new_address_scroll" data-kt-scroll="true" data-kt-scroll-activate="{default: false, lg: true}" data-kt-scroll-max-height="auto" data-kt-scroll-dependencies="#kt_modal_new_address_header" data-kt-scroll-wrappers="#kt_modal_new_address_scroll" data-kt-scroll-offset="300px">
                                                <div className="row mb-5">
                                                    <div className="col-md-4">
                                                        <label className="required fs-5 fw-bold mb-2">Doc No</label>
                                                        <input type="text" className="form-control form-control-solid" value={orderNumber} readOnly />
                                                    </div>
                                                    <div className="col-md-3">
                                                        <label className="required fs-5 fw-bold mb-2">Date</label>
                                                        {/* <DatePicker selected={orderDate} onChange={(date) => setOrderDate(date)} /> */}
                                                        <input type="date" className="form-control form-control-solid" max={new Date().toISOString().split('T')[0]} value={orderDate} onChange={(e) => { setOrderDate(e.target.value) }} onClick={(e) => { e.target.showPicker(); }} />
                                                    </div>
                                                    <div className="col-md-5">
                                                        <label className="required fs-5 fw-bold mb-2">Select Brands</label>
                                                        <div className="d-flex gap-1">
                                                            <div className="flex-grow-1">
                                                                <Select
                                                                    styles={{
                                                                        // Fixes the overlapping problem of the component
                                                                        menu: provided => ({ ...provided, zIndex: 9999 })
                                                                    }}
                                                                    //styles={userTheme == 'dark' ? dropdownStyleDark : {}}
                                                                    isMulti
                                                                    options={brandList.map(x => { return { label: x.brand_name, value: x.brand_id } })}
                                                                    value={selectedBrand}
                                                                    onChange={(val) => {
                                                                        let difference = selectedBrand.filter(x => !val.includes(x)); // calculates diff
                                                                        if (difference.length > 0) {
                                                                            let temp = [...itemArray];
                                                                            for (let i = 0; i < temp.length; i++) {
                                                                                if (temp[i].brand_id == difference[0].value) {
                                                                                    temp[i].product_id = "";
                                                                                    temp[i].product_name = "";
                                                                                }
                                                                            }
                                                                            setItemArray(temp);
                                                                        }
                                                                        setSelectedBrand(val);
                                                                    }}
                                                                    onInputChange={(val) => {
                                                                        if (val.length > 1) {
                                                                            getBrands(val)
                                                                        }
                                                                    }}
                                                                    onMenuClose={() => {
                                                                        getBrands()
                                                                    }}
                                                                    isLoading={brandListAPIState}
                                                                />
                                                            </div>
                                                            <button type="button" onClick={(e) => {
                                                                if ((selectedBrand.map(s => s.value)).length > 0) {
                                                                    getBrandsProduct(selectedBrand.map(s => s.value), "", "");
                                                                }
                                                                else {
                                                                    swal("Oops!", "Need to select atleast one brand!", "warning");
                                                                }
                                                            }} className="btn btn-secondary py-1">
                                                                <i className="bi bi-search p-0"></i></button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row mb-5">
                                                    <div className="col-md-4">
                                                        <label className="required fs-5 fw-bold mb-2">invoice No</label>
                                                        <input type="text" className="form-control form-control-solid" value={invoiceNumber} onChange={(e) => { setInvoiceNumber(e.target.value) }} />
                                                    </div>
                                                    <div className="col-md-4">
                                                        <label className="required fs-5 fw-bold mb-2">ISD Name</label>
                                                        <input type="text" className="form-control form-control-solid" value={user_name} readOnly />
                                                    </div>
                                                    <div className="col-md-4">
                                                        <label className="required fs-5 fw-bold mb-2">Select Dealer</label>
                                                        <Select
                                                            options={dealerList.map(x => { return { label: x.dealer_display_name + " - " + x.email, value: x.cid } })}
                                                            isMulti
                                                            onChange={(val) => { setSelectedDealer(val); }}
                                                            value={selectedDealer}
                                                            styles={userTheme == 'dark' ? dropdownStyleDark : {}}
                                                            // onInputChange={(val) => { (val.length > search_length) && getDealers(val) }}
                                                            // onMenuClose={() => { getDealers(); }}
                                                            isLoading={DealerApiState}
                                                            isDisabled={props.match.params.id}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="row gx-0 mb-1" style={{ transition: "all 1s ease-in-out", opacity: itemArray.length !== 0 ? "1" : "0", visibility: itemArray.length !== 0 ? "visible" : "hidden", height: itemArray.length !== 0 ? "auto" : "0", marginBottom: itemArray.length !== 0 ? "1rem" : "0", overflowX: "auto" }} >
                                                    <div className='bg-light-primary border border-primary d-flex flex-column w-100 p-5 rounded mb-3' style={{ minWidth: "1000px" }}>
                                                        {
                                                            itemArray.map((obj, indx, arr) => {
                                                                return (
                                                                    <div key={indx} className="row g-1 mb-8 text-center">
                                                                        <div className="col-3">
                                                                            <label className="required fs-5 fw-bold mb-2">Select Product</label>
                                                                            <Select
                                                                                options={itemList.map(x => { return { label: x.product_name, value: x.pid, brand_id: x.brand_id } })}
                                                                                onChange={(val) => {
                                                                                    if (itemArray.filter(option => (option.product_id == val.value && option.product_name == val.label)).length > 0) {
                                                                                        swal("Oops!", "This product already selected.", "warning");
                                                                                    }
                                                                                    else {
                                                                                        setItemArrIndex(indx);
                                                                                        let temp = itemArray.map(a => { return { ...a } });
                                                                                        temp[indx].product_id = val.value;
                                                                                        temp[indx].product_name = val.label;
                                                                                        temp[indx].brand_id = val.brand_id;
                                                                                        setItemArray(temp)
                                                                                    }
                                                                                }}
                                                                                // onInputChange={(val) => { (val.length > search_length) && getItems(val); }}
                                                                                // onMenuClose={() => { getItems(); }}
                                                                                isLoading={ItemApiState}
                                                                                value={{ label: obj.product_name, value: obj.product_id }}
                                                                                onMenuOpen={() => { setmenuBlockScroll(true); }}
                                                                                menuPosition='fixed'
                                                                                menuShouldBlockScroll={menuBlockScroll}
                                                                                components={{
                                                                                    MenuList: (props) => {
                                                                                        return (
                                                                                            <components.MenuList  {...props}>
                                                                                                {props.children}
                                                                                                <div className='d-flex justify-content-center'>
                                                                                                    <button className='btn btn-success rounded btn-sm my-1' onClick={() => { setmenuBlockScroll(false); setItemModalShow(true) }} >&#10011; Add New Item</button>
                                                                                                </div>
                                                                                            </components.MenuList >
                                                                                        )
                                                                                    }
                                                                                }}
                                                                                placeholder="Select Product"
                                                                                styles={userTheme == 'dark' ? dropdownStyleDark : {}}
                                                                            />
                                                                        </div>
                                                                        <div className="col-1">
                                                                            <label className="required fs-5 fw-bold mb-2">Quantity</label>
                                                                            <input type="number" className="form-control px-2"
                                                                                onChange={(e) => {
                                                                                    let temp = itemArray.map(a => { return { ...a } });
                                                                                    temp[indx].quantity = e.target.value == "" ? 0 : parseFloat(e.target.value);
                                                                                    setItemArray(temp)
                                                                                }} value={itemArray[indx].quantity.toString()} />
                                                                        </div>
                                                                        <div className="col-2">
                                                                            <label className="fs-5 fw-bold mb-2">Serial Number</label><br />
                                                                            {obj.serial_number_list.length == 0 ?
                                                                                <button className='btn btn-success rounded btn-sm my-1' onClick={() => { setItemArrIndex(indx); setSerialModalShow(true) }}>✛ Add Serial</button>
                                                                                :
                                                                                <>
                                                                                    {obj.serial_number_list.map((Obj1, index1) => {
                                                                                        return (
                                                                                            <>
                                                                                                <span className="badge badge-secondary me-2">{Obj1}</span>
                                                                                            </>
                                                                                        )
                                                                                    })}
                                                                                    <button onClick={() => { setItemArrIndex(indx); setSerialModalShow(true) }} class="btn btn-sm px-3"><i class="fa-solid fa-pencil fs-2 text-hover-success"></i></button>
                                                                                </>
                                                                            }

                                                                            {/* <input type="text" className="form-control px-2" 
                                                                onChange={(val) => {
                                                                    let temp = itemArray.map(a => { return { ...a } });
                                                                    temp[indx].item = val;
                                                                    setItemArray(temp)
                                                                }}
                                                                value={itemArray[indx].item}/> */}
                                                                        </div>
                                                                        <div className="col-2">
                                                                            <label className="fs-5 fw-bold mb-2">MOP Price ({Currency_symbol})</label>
                                                                            <input type="number" className="form-control px-2" onChange={(e) => {
                                                                                let temp = itemArray.map(a => { return { ...a } });
                                                                                temp[indx].mop_price = e.target.value == "" ? 0 : parseFloat(e.target.value);
                                                                                setItemArray(temp)
                                                                            }}
                                                                                value={itemArray[indx].mop_price.toString()}
                                                                            />
                                                                        </div>
                                                                        <div className="col-2">
                                                                            <label className="required fs-5 fw-bold mb-2">Selling Price ({Currency_symbol})</label>
                                                                            <input type="number" className="form-control px-2" onChange={(e) => {
                                                                                let temp = itemArray.map(a => { return { ...a } });
                                                                                temp[indx].selling_price = e.target.value == "" ? 0 : parseFloat(e.target.value);
                                                                                setItemArray(temp)
                                                                            }} value={itemArray[indx].selling_price.toString()} />
                                                                        </div>
                                                                        <div className="col-2">
                                                                            <label className="required fs-5 fw-bold mb-2">Total ({Currency_symbol})</label>
                                                                            <input type="number" className="form-control px-2" value={trimDecimalPlaces((Number(obj.quantity) * Number(obj.selling_price)), decimal_place)} readOnly />
                                                                        </div>
                                                                        {
                                                                            arr.length > 1 ?
                                                                                <div className="col-1">
                                                                                    <button className="btn btn-link mt-6" onClick={() => {
                                                                                        let temp = itemArray.map(a => { return { ...a } })
                                                                                        temp.splice(indx, 1)
                                                                                        setItemArray(temp)
                                                                                    }}>
                                                                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="38px" height="38px"><path fill="#f44336" d="M44,24c0,11.045-8.955,20-20,20S4,35.045,4,24S12.955,4,24,4S44,12.955,44,24z" /><path fill="#fff" d="M29.656,15.516l2.828,2.828l-14.14,14.14l-2.828-2.828L29.656,15.516z" /><path fill="#fff" d="M32.484,29.656l-2.828,2.828l-14.14-14.14l2.828-2.828L32.484,29.656z" /></svg>
                                                                                    </button>
                                                                                </div>
                                                                                :
                                                                                <div className="col" style={{ visibility: "hidden" }}></div>
                                                                        }
                                                                    </div>
                                                                )
                                                            })
                                                        }
                                                        <div className="row mb-5">
                                                            <div className="col-md-3">
                                                                <button className='btn btn-primary rounded fs-7' onClick={() => { setItemArray([...itemArray, { product_id: "", product_name: "", quantity: 1, serial_number_list: [], mop_price: 0, selling_price: 0 }]) }}>&#10011; Add a row</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row mb-5">
                                                    <div className="col-md-6">
                                                        <label className="required fs-5 fw-bold mb-2">Customer Name</label>
                                                        <Select
                                                            options={customerList.map(x => { return { label: x.customer_display_name + " - " + x.email, value: x.cid } })}
                                                            onChange={(val) => { getCustomerDetails(val.value); setSelectedCustomer(val); }}
                                                            value={selectedCustomer}
                                                            styles={userTheme == 'dark' ? dropdownStyleDark : {}}
                                                            // onInputChange={(val) => { (val.length > search_length) && getDealers(val) }}
                                                            // onMenuClose={() => { getDealers(); }}
                                                            isLoading={customerApiState}
                                                            components={{
                                                                MenuList: (props) => {
                                                                    return (
                                                                        <components.MenuList  {...props}>
                                                                            {props.children}
                                                                            <div className='d-flex justify-content-center'>
                                                                                <button className='btn btn-success rounded btn-sm my-1' onClick={() => { setmenuBlockScroll(false); setCustomerModalShow(true) }} >&#10011; Add New Customer</button>
                                                                            </div>
                                                                        </components.MenuList >
                                                                    )
                                                                }
                                                            }}
                                                        />
                                                    </div>
                                                    <div className="col-md-6">
                                                        <label className="fs-5 fw-bold mb-2">Mobile No</label>
                                                        <input type="text" className="form-control" onChange={(e) => { setCustomerMobileNumber(e.target.value); }} value={customerMobileNumber} />
                                                    </div>
                                                </div>
                                                {
                                                    selectedCustomer != null &&
                                                    <>
                                                        <div className="row gx-0" >
                                                            <div className="col-md-6 px-1">
                                                                <div className="card card-dashed p-4 flex-row">

                                                                    {
                                                                        selectedBillingAddress.length !== 0 ?
                                                                            <>
                                                                                <div className="fs-6 fw-semibold text-gray-600">{`${selectedBillingAddress.city}, ${selectedBillingAddress.state}, ${selectedBillingAddress.pincode}, ${selectedBillingAddress.country}`}</div>
                                                                            </>
                                                                            :
                                                                            <div className='text-hover-primary'>No billing address added</div>
                                                                    }

                                                                </div>
                                                            </div>

                                                            <div className="col-md-6 px-1">
                                                                <div className="card card-dashed p-4 flex-row">

                                                                    {
                                                                        selectedShippingAddress.length !== 0 ?
                                                                            <>
                                                                                <div className="fs-6 fw-semibold text-gray-600">{`${selectedShippingAddress.city}, ${selectedShippingAddress.state}, ${selectedShippingAddress.pincode}, ${selectedShippingAddress.country}`}</div>
                                                                            </>
                                                                            :
                                                                            <div className='text-hover-primary'>No shipping address added</div>
                                                                    }

                                                                </div>
                                                            </div>
                                                        </div>
                                                    </>
                                                }
                                                <div className="row mb-5">
                                                    <div className="col-md-12 fv-row">
                                                        <label className="fs-5 fw-bold mb-2">Upload Invoices</label>
                                                        <Dropzone
                                                            getUploadParams={getUploadParams2}
                                                            onChangeStatus={handleChangeStatus2}
                                                            //LayoutComponent={CustomLayout}
                                                            PreviewComponent={Preview}
                                                            styles={{
                                                                dropzone: { overflow: 'auto', border: '1px solid #999', background: '#f5f5f5' },
                                                                inputLabelWithFiles: { margin: '20px 3%' }
                                                            }}
                                                            maxFiles={3}
                                                            maxSizeBytes={1024 * 1024 * 2}
                                                            accept="image/*,.pdf"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="modal-footer flex-center">
                                            <button type="submit"
                                                className="btn btn-primary rounded"
                                                onClick={(e) => { submitSaleDetails(e) }}
                                                data-kt-indicator={mainSubmitButtonState ? "on" : "off"}
                                                disabled={mainSubmitButtonState}
                                            >
                                                <span className="indicator-label">Submit</span>
                                                <span className="indicator-progress">Please wait...
                                                    <span className="spinner-border spinner-border-sm align-middle ms-2"></span></span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </>
                            :
                            <div className="card modal-body pt-0 pb-15 px-5 px-xl-20">
                                <br />

                                {state == 2 ?
                                    <img src="/images/loader-06.svg" alt="" style={loaderstyle} />
                                    :
                                    <>
                                        <div className="flex-lg-row-fluid me-lg-15">
                                            <div className="card card-flush pt-3 mb-5 mb-lg-10">
                                                <div className="card-header"></div>
                                                <div className="card-body pt-0">
                                                    <div className="notice d-flex bg-light-primary rounded border-primary border border-dashed rounded-3 p-6">
                                                        <div className="d-flex flex-stack flex-grow-1">
                                                            <div className="fw-bold">
                                                                <h4 className="text-gray-800 fw-bolder">Something Went Wrong</h4>
                                                                <div className="fs-6 text-gray-600">
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                }

                                <br />
                            </div>
                        }
                    </div>
                </div>
            </div>
            <Modal show={CustomerModalShow} onHide={() => { handleNewCustomerModalClose() }} size="lg" centered>
                <Modal.Header>
                    <Modal.Title>Add Customer</Modal.Title>
                    <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={() => { handleNewCustomerModalClose() }}>
                        <span className="svg-icon svg-icon-1">
                            <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                <g transform="translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)" fill="#000000">
                                    <rect fill="#000000" x="0" y="7" width="16" height="2" rx="1" />
                                    <rect fill="#000000" opacity="0.5" transform="translate(8.000000, 8.000000) rotate(-270.000000) translate(-8.000000, -8.000000)" x="0" y="7" width="16" height="2" rx="1" />
                                </g>
                            </svg>
                        </span>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div className='container'>
                        <div className="row mb-5">
                            <div className='col-4 my-auto'>
                                <label className="fs-5 fw-bold mb-2">Customer Type</label>
                            </div>
                            <div className='col-4'>
                                <label className="fs-5 mb-2" onClick={() => { setCustomerType("business") }}> Business
                                    <input type="radio" className="form-check-input ms-5" checked={customerType == "business"} />
                                </label>
                            </div>
                            <div className='col-4'>
                                <label className="fs-5 mb-2" onClick={() => { setCustomerType("individual") }}>Individual
                                    <input type="radio" className="form-check-input ms-5" checked={customerType == "individual"} />
                                </label>
                            </div>
                        </div>

                        <div className="row mb-5">
                            <div className="col-3 my-auto">
                                <label className="required fs-5 fw-bold mb-2">Primary Contact</label>
                            </div>
                            <div className='col-3 my-auto'>
                                <Select
                                    styles={userTheme == 'dark' ? dropdownStyleDark : {}}
                                    options={["Mr.", "Mrs.", "Miss.", "Dr.", "M/s", "Prof."].map(x => { return { label: x, value: x } })}
                                    value={primaryContact.salutation}
                                    onChange={(val) => {
                                        setPrimaryContact({ ...primaryContact, salutation: val })
                                    }}
                                    isClearable
                                    placeholder="Salutation"
                                />
                            </div>
                            <div className='col-6 input-group-text p-0'>
                                <input type="text" className="form-control form-control-solid" value={primaryContact.firstName} onChange={(e) => { setPrimaryContact({ ...primaryContact, firstName: e.target.value }) }} placeholder='First Name' />
                                <input type="text" className="form-control form-control-solid" value={primaryContact.lastName} onChange={(e) => { setPrimaryContact({ ...primaryContact, lastName: e.target.value }) }} placeholder='Last Name' />
                            </div>
                        </div>
                        <div className="row mb-5">
                            <div className="col-md-6 my-auto">
                                <label className="required fs-5 fw-bold mb-2">Customer Display Name</label>
                                <Select
                                    styles={userTheme == 'dark' ? dropdownStyleDark : {}}
                                    options={customerDisplayNameOptions.map(x => { return { label: x, value: x } })}
                                    value={selectedCustomerDisplayName}
                                    onChange={(val) => { setSelectedCustomerDisplayName(val) }}
                                />
                            </div>
                        </div>

                        <div className="row mb-5">
                            <div className="col-md-6">
                                <label className="required fs-5 fw-bold mb-2">Work Phone</label>
                                <input type="number" className="form-control form-control-solid" value={workPhone} onChange={(e) => { setWorkPhone(e.target.value) }} />
                            </div>
                            <div className="col-md-6">
                                <label className={"required fs-5 fw-bold mb-2"}>Email</label>
                                <input type="email" className="form-control form-control-solid" value={email} onChange={(e) => { setEmail(e.target.value) }} />
                            </div>
                        </div>
                        <div className="row mb-5">
                            <div className="col-md-6">
                                <label className="required fs-5 fw-bold mb-2">Place Of Supply</label>
                                <Select
                                    styles={userTheme == 'dark' ? dropdownStyleDark : {}}
                                    options={SupplyStateOptions}
                                    onChange={(val) => { setPlaceSupply(val) }}
                                    value={placeSupply}
                                    isClearable
                                />
                            </div>
                            <div className="col-md-6">
                                <label className="required fs-5 fw-bold mb-2">GST Treatment</label>
                                <Select
                                    styles={userTheme == 'dark' ? dropdownStyleDark : {}}
                                    options={gstTreatmentlist}
                                    value={gstTreatment}
                                    onChange={(val) => {
                                        if (val.value === "Consumer" || val.value === "Unregistered Business") {
                                            setGstIN("");
                                            setLegalName("");
                                            setTradeName("");
                                        }
                                        setGstTreatment(val)
                                    }}
                                    components={{
                                        Option: (props) => {
                                            //console.log(props);
                                            return (
                                                <components.Option  {...props}>
                                                    {props.children}
                                                    <span class="fw-semibold text-gray-400 d-block fs-8">{props.data.description}</span>
                                                </components.Option >
                                            )
                                        }
                                    }}
                                />
                            </div>
                        </div>
                        {(gstTreatment !== null && (gstTreatment.value !== "Consumer" && gstTreatment.value !== "Unregistered Business")) &&
                            <div className="row mb-5">
                                <div className="col-md-4 fv-row">
                                    <label className="required fs-5 fw-bold mb-2">GSTIN</label>
                                    <input id="GSTIN" type="text" className="form-control mb-2" placeholder="" name="GSTIN" value={GstIN} onChange={(e) => { setGstIN(e.target.value) }} />
                                </div>
                                <div className="col-md-4 fv-row">
                                    <label className="required fs-5 fw-bold mb-2">Business Legal Name</label>
                                    <input id="Business_Legal_Name" type="text" className="form-control mb-2" placeholder="" name="Business_Legal_Name" value={LegalName} onChange={(e) => { setLegalName(e.target.value) }} />
                                </div>
                                <div className="col-md-4 fv-row">
                                    <label className="fs-5 fw-bold mb-2">Business Trade Name</label>
                                    <input id="Business_Trade_Name" type="text" className="form-control mb-2" placeholder="" name="Business_Trade_Name" value={TradeName} onChange={(e) => { setTradeName(e.target.value) }} />
                                </div>
                            </div>}
                        <div className="row mb-5">
                            <div className="col-md-6">
                                <label className={`${billingAddressFlag === true && "required "}fs-5 fw-bold mb-2`}>Country</label>
                                <Select
                                    styles={userTheme == 'dark' ? dropdownStyleDark : {}}
                                    options={billingCountryOptions}
                                    value={billingSelectedCountry}
                                    onChange={(val) => { setBillingSelectedCountry(val); setBillingSelectedState(null); loadBillingStateOptions(val); }}
                                />
                            </div>

                            <div className="col-md-6">
                                <label className={`${billingAddressFlag === true && "required "}fs-5 fw-bold mb-2`}>State / Province / Region</label>
                                <Select
                                    styles={userTheme == 'dark' ? dropdownStyleDark : {}}
                                    options={billingStateOptions}
                                    value={billingSelectedState}
                                    onChange={(val) => { setBillingSelectedState(val) }}
                                />
                            </div>
                        </div>
                        <div className="row mb-5">
                            <div className="col-md-6">
                                <label className={`${billingAddressFlag === true && "required "}fs-5 fw-bold mb-2`}>Town/City</label>
                                <input type="text" className="form-control form-control-solid" value={billingCity} onChange={(e) => { setBillingCity(e.target.value) }} />
                            </div>
                            <div className="col-md-6">
                                <label className={`${billingAddressFlag === true && "required "}fs-5 fw-bold mb-2`}>Pin Code</label>
                                <input type="text" className="form-control form-control-solid" value={billingPincode} onChange={(e) => { setBillingPincode(e.target.value) }} />
                            </div>
                        </div>
                        <label className="form-check form-check-custom form-check-solid align-items-start">
                            <input className="form-check-input me-3" type="checkbox" name="email-preferences[]" value={Shipping_flag} onChange={(e) => {
                                setShipping_flag(e.target.checked);
                            }} />
                            <span className="form-check-label d-flex flex-column align-items-start">
                                <span className="fw-bolder fs-5 mb-0">Use the same address for shipping.</span>
                                {/* {Shipping_flag &&<span className="text-muted fs-6">Your default data will not save for this organization.</span>} */}
                            </span>
                        </label>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-danger rounded" onClick={() => { handleNewCustomerModalClose() }}>Close</button>
                    {
                        write == 1 &&
                        <button className="btn btn-success rounded" data-kt-indicator={customerSubmitButtonState ? "on" : "off"} disabled={customerSubmitButtonState} onClick={() => { submitCustomerDetails() }}>
                            <span className="indicator-label">Save and Continue</span>
                            <span className="indicator-progress">Please wait...
                                <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                            </span>
                        </button>
                    }
                </Modal.Footer>
            </Modal>
            <Modal show={ItemModalShow} onHide={() => { setItemModalShow(false) }} size="lg" centered>
                <Modal.Header>
                    <Modal.Title>Add Item</Modal.Title>
                    <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={() => { setItemModalShow(false) }}>
                        <span className="svg-icon svg-icon-1">
                            <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                <g transform="translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)" fill="#000000">
                                    <rect fill="#000000" x="0" y="7" width="16" height="2" rx="1" />
                                    <rect fill="#000000" opacity="0.5" transform="translate(8.000000, 8.000000) rotate(-270.000000) translate(-8.000000, -8.000000)" x="0" y="7" width="16" height="2" rx="1" />
                                </g>
                            </svg>
                        </span>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div className='container'>
                        <div className="fv-row mb-10">
                            <label className="fs-6 fw-semibold mb-2">Type</label>
                            <div className="row">
                                <div className="col">
                                    <label className={`btn btn-outline btn-outline-dashed btn-active-light-primary d-flex text-start p-6 ${Product_type === "Goods" && "active"}`} data-kt-button="true">
                                        <span className="form-check form-check-custom form-check-solid form-check-sm align-items-start mt-1">
                                            <input className="form-check-input" type="radio" name="discount_option" value="2" onChange={(e) => { setProduct_type("Goods") }} checked={Product_type === "Goods"} />
                                        </span>
                                        <span className="ms-5"><span className="fs-4 fw-bold text-gray-800 d-block">Goods</span></span>
                                    </label>
                                </div>
                                <div className="col">
                                    <label className={`btn btn-outline btn-outline-dashed btn-active-light-primary d-flex text-start p-6 ${Product_type === "Service" && "active"}`} data-kt-button="true">
                                        <span className="form-check form-check-custom form-check-solid form-check-sm align-items-start mt-1">
                                            <input className="form-check-input" type="radio" name="discount_option" value="3" onChange={(e) => { setProduct_type("Service") }} checked={Product_type === "Service"} />
                                        </span>
                                        <span className="ms-5"><span className="fs-4 fw-bold text-gray-800 d-block">Service</span></span>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div className="mb-5">
                            <label className="required form-label">Item Name</label>
                            <input type="text" name="product_name" className="form-control mb-2" placeholder="Item name" value={ItemName} onChange={(e) => { setItemName(e.target.value) }} />
                            <div className="text-muted fs-7">A Item name is required and recommended to be unique.</div>
                        </div>
                        <div className="mb-5">
                            <label className="required form-label">Unit</label>
                            <Select
                                styles={userTheme == 'dark' ? dropdownStyleDark : {}}
                                options={UnitSelectionList}
                                onChange={(event) => { setUnit(event.value); }}
                                value={UnitSelectionList.filter(option => option.value == Unit).length != 0 && UnitSelectionList.filter(option => option.value == Unit)[0]}
                                placeholder="--Select product Unit--"
                            />
                            <div className="text-muted fs-7">Enter the product Unit.</div>
                        </div>
                        <div className="mb-5">
                            <label className="required form-label">Brand</label>
                            <Select
                                styles={userTheme == 'dark' ? dropdownStyleDark : {}}
                                options={brandList.map(x => { return { label: x.brand_name, value: x.brand_id } })}
                                onChange={(val) => { setBrand(val); }}
                                value={brand}
                                placeholder="--Select product Brand--"
                            />
                            <div className="text-muted fs-7">Enter the product Brand.</div>
                        </div>
                        <div className="mb-5">
                            <label className="required form-label">Tax Preference</label>
                            <Select
                                styles={userTheme == 'dark' ? dropdownStyleDark : {}}
                                options={TaxSelectionList}
                                onChange={(event) => { setTaxPreference(event.value); }}
                                value={TaxSelectionList.filter(option => option.value == TaxPreference).length != 0 && TaxSelectionList.filter(option => option.value == TaxPreference)[0]}
                                placeholder="--Select Tax Preference--"
                            />
                            <div className="text-muted fs-7">Enter the Tax Preference.</div>
                        </div>
                        {
                            TaxPreference == "Taxable" &&
                            <>
                                <div className="mb-5">
                                    <label className="fs-6 fw-semibold mb-2">Tax Calculation Method</label>
                                    <div className="d-flex align-items-center">
                                        <div className={`rounded mx-2 px-6 py-2 ${TaxCalculationMethod == "TAX_Inclusive" && "bg-primary"}`} onClick={() => { setTaxCalculationMethod("TAX_Inclusive"); }}>TAX Inclusive</div>
                                        <div className={`rounded mx-2 px-6 py-2 ${TaxCalculationMethod == "TAX_Exclusive" && "bg-primary"}`} onClick={() => { setTaxCalculationMethod("TAX_Exclusive"); }}>TAX Exclusive</div>
                                    </div>
                                </div>
                                <div className="mb-5">
                                    <label className="form-label">Intra State Tax Rate</label>
                                    <Select
                                        styles={userTheme == 'dark' ? dropdownStyleDark : {}}
                                        options={taxGroupList.filter(x => x.tax_group_type != "INTERSTATE").map(x => { return { label: x.tax_group_name, value: x.tax_group_id } })}
                                        onChange={(event) => { Default_tax_preference.Intra_State_Tax = event.value; }}
                                        value={Default_tax_preference.Intra_State_Tax != "" && { label: taxGroupList.find(x => x.tax_group_id == Default_tax_preference.Intra_State_Tax).tax_group_name, value: Default_tax_preference.Intra_State_Tax }}
                                        placeholder="--Select Intra state tax group--"
                                    />
                                    <div className="text-muted fs-7">Set the Intra State Tax Rate.</div>
                                </div>
                                <div className="mb-5">
                                    <label className="form-label">Inter State Tax Rate</label>
                                    <Select
                                        styles={userTheme == 'dark' ? dropdownStyleDark : {}}
                                        options={taxGroupList.filter(x => x.tax_group_type == "INTERSTATE").map(x => { return { label: x.tax_group_name, value: x.tax_group_id } })}
                                        onChange={(event) => { Default_tax_preference.Inter_State_Tax = event.value; }}
                                        value={Default_tax_preference.Inter_State_Tax != "" && { label: taxGroupList.find(x => x.tax_group_id == Default_tax_preference.Inter_State_Tax).tax_group_name, value: Default_tax_preference.Inter_State_Tax }}
                                        placeholder="--Select Inter state tax group--"
                                    />
                                    <div className="text-muted fs-7">Set the Inter State Tax Rate.</div>
                                </div>
                            </>
                        }

                        <label className="form-check form-check-custom form-check-solid align-items-start">
                            <input className="form-check-input me-3" type="checkbox" name="email-preferences[]" checked={Tracking_inventory === true} value={Tracking_inventory} onChange={(e) => { setTracking_inventory(e.target.checked) }} />
                            <span className="form-check-label d-flex flex-column align-items-start">
                                <span className="fw-bolder fs-5 mb-0">Track Inventory for this item</span>
                                {Tracking_inventory && <span className="text-muted fs-6">You cannot enable/disable inventory tracking once you've created transactions for this item</span>}
                            </span>
                        </label>

                        {
                            Tracking_inventory === true &&
                            <div className="mb-5">
                                <label className="required fw-semibold fs-6 mb-5">Advanced Inventory Tracking</label>
                                <div className="d-flex fv-row">
                                    <div className="form-check form-check-custom form-check-solid">
                                        <input className="form-check-input me-3" name="user_role" type="radio" onChange={(e) => { setTracking_inventory_type("None") }} checked={Tracking_inventory_type === "None"} />
                                        <label className="form-check-label" for="kt_modal_update_role_option_0">
                                            <div className="fw-bold text-gray-800">None</div>
                                            <div className="text-gray-600"></div>
                                        </label>
                                    </div>
                                </div>
                                <div className="separator separator-dashed my-5"></div>
                                <div className="d-flex fv-row">
                                    <div className="form-check form-check-custom form-check-solid">
                                        <input className="form-check-input me-3" name="user_role" type="radio" onChange={(e) => { setTracking_inventory_type("Track Serial Number") }} checked={Tracking_inventory_type === "Track Serial Number"} />
                                        <label className="form-check-label" for="kt_modal_update_role_option_1">
                                            <div className="fw-bold text-gray-800">Track Serial Number</div>
                                            <div className="text-gray-600"></div>
                                        </label>
                                    </div>
                                </div>
                                <div className="separator separator-dashed my-5"></div>
                                <div className="d-flex fv-row">
                                    <div className="form-check form-check-custom form-check-solid">
                                        <input className="form-check-input me-3" name="user_role" type="radio" onChange={(e) => { setTracking_inventory_type("Track Batches") }} checked={Tracking_inventory_type === "Track Batches"} />
                                        <label className="form-check-label" for="kt_modal_update_role_option_2">
                                            <div className="fw-bold text-gray-800">Track Batches</div>
                                            <div className="text-gray-600"></div>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-danger rounded" onClick={() => { setItemModalShow(false) }}>Close</button>
                    {
                        write == 1 &&
                        <button className="btn btn-success rounded" data-kt-indicator={itemSubmitButtonState ? "on" : "off"} disabled={itemSubmitButtonState} onClick={() => { submitItemDetails() }}>
                            <span className="indicator-label">Save and Continue</span>
                            <span className="indicator-progress">Please wait...
                                <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                            </span>
                        </button>
                    }
                </Modal.Footer>
            </Modal>
            <Modal show={SerialModalShow} onHide={() => { setSerialModalShow(false) }} size="lg" centered>
                <Modal.Header>
                    <Modal.Title>Add Serial</Modal.Title>
                    <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={() => { setSerialModalShow(false) }}>
                        <span className="svg-icon svg-icon-1">
                            <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                <g transform="translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)" fill="#000000">
                                    <rect fill="#000000" x="0" y="7" width="16" height="2" rx="1" />
                                    <rect fill="#000000" opacity="0.5" transform="translate(8.000000, 8.000000) rotate(-270.000000) translate(-8.000000, -8.000000)" x="0" y="7" width="16" height="2" rx="1" />
                                </g>
                            </svg>
                        </span>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div className='container'>
                        <div className="d-flex flex-wrap gap-2 align-items-center mb-2">
                            <div className="flex-grow-1">
                                <input type="text" className="form-control" placeholder="Enter Serial Number" value={SerialName} onChange={(e) => {
                                    setSerialName(e.target.value);
                                }} id="myInput" />
                            </div>
                            <div className="">
                                <button onClick={(e) => {
                                    Add_serial(itemarrindex);
                                }} className="btn btn-sm btn-primary me-3 rounded">
                                    <span className="svg-icon svg-icon-2">
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <rect opacity="0.5" x="11" y="18" width="12" height="2" rx="1" transform="rotate(-90 11 18)" fill="currentColor"></rect>
                                            <rect x="6" y="11" width="12" height="2" rx="1" fill="currentColor"></rect>
                                        </svg>
                                    </span>
                                    <span className="indicator-label">Add</span>
                                    <span className="indicator-progress">Please wait...
                                        <span className="spinner-border spinner-border-sm align-middle ms-2"></span></span></button>
                                <div className="text-muted fs-7"></div>
                            </div>
                        </div>
                        <br />
                        {(itemArray[itemarrindex] !== undefined && itemArray[itemarrindex].serial_number_list.length > 0) &&
                            <>
                                <div className="separator separator-dashed mb-2"></div>
                                <label className="form-label">Selected Serial Number:</label>
                                <br />
                            </>
                        }
                        <div className="d-flex align-items-center gap-2 gap-lg-3 flex-wrap">
                            {
                                (itemArray[itemarrindex] !== undefined && itemArray[itemarrindex].serial_number_list.length > 0) && itemArray[itemarrindex].serial_number_list.map((obj, index) => {
                                    return (
                                        <div className="btn btn-sm btn-light d-flex align-items-center px-2">
                                            <div className="text-gray-600 fw-bold">{obj}</div>
                                            <button type="button" style={{ width: "auto", height: "auto", marginLeft: "1rem" }} onClick={(e) => { Remove_serial(index) }} className="btn btn-clean btn-sm btn-icon btn-icon-primary btn-active-light-primary">
                                                <span className="svg-icon svg-icon-4">
                                                    <svg id="edit-svg" style={{ "width": "30%", "height": "40%" }} mi-view-box="0 0 1024 1024" viewBox="0 0 1024 1024">
                                                        <rect fill="white" x="0" y="0" mi-width="1024" mi-height="1024" width="1024" height="1024"></rect>
                                                        <g>
                                                            <path className="cursor-pointer " ng-repeat="path in icon.paths track by tempIds[$index]" mi-d="M721.349 237.158h-65.154v-104.092c0-28.594-23.264-51.858-51.858-51.858h-184.68c-28.594 0-51.858 23.264-51.858 51.858v104.092h-65.154v-104.092c0-64.52 52.492-117.010 117.012-117.010h184.68c64.52 0 117.012 52.492 117.012 117.010v104.092z" mi-fill="rgb(228, 93, 76)" mi-stroke="inherit" mi-stroke-width="inherit" mi-stroke-linejoin="inherit" mi-stroke-linecap="inherit" mi-stroke-miterlimit="inherit" mi-opacity="1" ng-click="selectPath($index)" mi-absorb-clicks="" d="M721.349 237.158h-65.154v-104.092c0-28.594-23.264-51.858-51.858-51.858h-184.68c-28.594 0-51.858 23.264-51.858 51.858v104.092h-65.154v-104.092c0-64.52 52.492-117.010 117.012-117.010h184.68c64.52 0 117.012 52.492 117.012 117.010v104.092z" fill="rgb(228, 93, 76)" stroke="inherit" stroke-width="inherit" stroke-linejoin="inherit" stroke-linecap="inherit" stroke-miterlimit="inherit" opacity="1">
                                                            </path><path className="cursor-pointer " ng-repeat="path in icon.paths track by tempIds[$index]" mi-d="M321.107 118.95c0-33.71 14.348-64.118 37.236-85.49-33.392 20.63-55.696 57.556-55.696 99.606v104.092h65.154v-14.116h-46.694v-104.092zM674.657 223.042v-104.092c0-28.594-23.264-51.858-51.858-51.858h-199.882c-27.080 0-49.368 20.87-51.652 47.37 7.494-19.43 26.356-33.254 48.394-33.254h184.678c28.594 0 51.858 23.264 51.858 51.858v104.092h65.154v-14.116c0-0-46.692-0-46.692-0z" mi-fill="rgb(0, 0, 0)" mi-stroke="inherit" mi-stroke-width="inherit" mi-stroke-linejoin="inherit" mi-stroke-linecap="inherit" mi-stroke-miterlimit="inherit" mi-opacity="0.1" ng-click="selectPath($index)" mi-absorb-clicks="" d="M321.107 118.95c0-33.71 14.348-64.118 37.236-85.49-33.392 20.63-55.696 57.556-55.696 99.606v104.092h65.154v-14.116h-46.694v-104.092zM674.657 223.042v-104.092c0-28.594-23.264-51.858-51.858-51.858h-199.882c-27.080 0-49.368 20.87-51.652 47.37 7.494-19.43 26.356-33.254 48.394-33.254h184.678c28.594 0 51.858 23.264 51.858 51.858v104.092h65.154v-14.116c0-0-46.692-0-46.692-0z" fill="rgb(0, 0, 0)" stroke="inherit" stroke-width="inherit" stroke-linejoin="inherit" stroke-linecap="inherit" stroke-miterlimit="inherit" opacity="0.1">
                                                            </path><path className="cursor-pointer " ng-repeat="path in icon.paths track by tempIds[$index]" mi-d="M916.65 262.053h-809.302l85.632 680.493c4.704 37.372 36.48 65.402 74.148 65.402h489.745c37.664 0 69.444-28.032 74.148-65.402l85.628-680.493z" mi-fill="rgb(164, 168, 171)" mi-stroke="inherit" mi-stroke-width="inherit" mi-stroke-linejoin="inherit" mi-stroke-linecap="inherit" mi-stroke-miterlimit="inherit" mi-opacity="1" ng-click="selectPath($index)" mi-absorb-clicks="" d="M916.65 262.053h-809.302l85.632 680.493c4.704 37.372 36.48 65.402 74.148 65.402h489.745c37.664 0 69.444-28.032 74.148-65.402l85.628-680.493z" fill="rgb(164, 168, 171)" stroke="inherit" stroke-width="inherit" stroke-linejoin="inherit" stroke-linecap="inherit" stroke-miterlimit="inherit" opacity="1">
                                                            </path><path className="cursor-pointer " ng-repeat="path in icon.paths track by tempIds[$index]" mi-d="M188.438 906.46l4.54 36.082c4.704 37.372 36.482 65.402 74.148 65.402h489.745c37.664 0 69.444-28.032 74.148-65.402l4.54-36.082h-647.121z" mi-fill="rgb(74, 80, 88)" mi-stroke="inherit" mi-stroke-width="inherit" mi-stroke-linejoin="inherit" mi-stroke-linecap="inherit" mi-stroke-miterlimit="inherit" mi-opacity="1" ng-click="selectPath($index)" mi-absorb-clicks="" d="M188.438 906.46l4.54 36.082c4.704 37.372 36.482 65.402 74.148 65.402h489.745c37.664 0 69.444-28.032 74.148-65.402l4.54-36.082h-647.121z" fill="rgb(74, 80, 88)" stroke="inherit" stroke-width="inherit" stroke-linejoin="inherit" stroke-linecap="inherit" stroke-miterlimit="inherit" opacity="1">
                                                            </path><path className="cursor-pointer " ng-repeat="path in icon.paths track by tempIds[$index]" mi-d="M916.648 262.053h-809.3l85.632 680.493c4.704 37.372 36.48 65.402 74.148 65.402h489.745c29.724 0 55.772-17.464 67.748-43.194v0c-9.622 4.49-20.32 6.998-31.552 6.998h-489.745c-37.664 0-69.444-28.032-74.148-65.402l-66.38-527.495h739.153l14.698-116.802z" mi-fill="rgb(0, 0, 0)" mi-stroke="inherit" mi-stroke-width="inherit" mi-stroke-linejoin="inherit" mi-stroke-linecap="inherit" mi-stroke-miterlimit="inherit" mi-opacity="0.1" ng-click="selectPath($index)" mi-absorb-clicks="" d="M916.648 262.053h-809.3l85.632 680.493c4.704 37.372 36.48 65.402 74.148 65.402h489.745c29.724 0 55.772-17.464 67.748-43.194v0c-9.622 4.49-20.32 6.998-31.552 6.998h-489.745c-37.664 0-69.444-28.032-74.148-65.402l-66.38-527.495h739.153l14.698-116.802z" fill="rgb(0, 0, 0)" stroke="inherit" stroke-width="inherit" stroke-linejoin="inherit" stroke-linecap="inherit" stroke-miterlimit="inherit" opacity="0.1">
                                                            </path><path className="cursor-pointer " ng-repeat="path in icon.paths track by tempIds[$index]" mi-d="M934 155.83h-844.002c-24.478 0-44.322 19.844-44.322 44.322v87.040c0 24.48 19.844 44.322 44.322 44.322h844.002c24.48 0 44.322-19.844 44.322-44.322v-87.040c0-24.476-19.844-44.322-44.322-44.322z" mi-fill="rgb(74, 80, 88)" mi-stroke="inherit" mi-stroke-width="inherit" mi-stroke-linejoin="inherit" mi-stroke-linecap="inherit" mi-stroke-miterlimit="inherit" mi-opacity="1" ng-click="selectPath($index)" mi-absorb-clicks="" d="M934 155.83h-844.002c-24.478 0-44.322 19.844-44.322 44.322v87.040c0 24.48 19.844 44.322 44.322 44.322h844.002c24.48 0 44.322-19.844 44.322-44.322v-87.040c0-24.476-19.844-44.322-44.322-44.322z" fill="rgb(74, 80, 88)" stroke="inherit" stroke-width="inherit" stroke-linejoin="inherit" stroke-linecap="inherit" stroke-miterlimit="inherit" opacity="1">
                                                            </path><path className="cursor-pointer " ng-repeat="path in icon.paths track by tempIds[$index]" mi-d="M963.172 301.701h-848.168c-21.822 0-39.514-17.692-39.514-39.514v-91.204c0-4.588 0.696-9.008 1.972-13.178-18.402 5.634-31.786 22.746-31.786 42.994v85.754c0 24.832 20.132 44.964 44.964 44.964h842.718c20.248 0 37.358-13.386 42.994-31.786-4.172 1.274-8.594 1.97-13.18 1.97z" mi-fill="rgb(0, 0, 0)" mi-stroke="inherit" mi-stroke-width="inherit" mi-stroke-linejoin="inherit" mi-stroke-linecap="inherit" mi-stroke-miterlimit="inherit" mi-opacity="0.2" ng-click="selectPath($index)" mi-absorb-clicks="" d="M963.172 301.701h-848.168c-21.822 0-39.514-17.692-39.514-39.514v-91.204c0-4.588 0.696-9.008 1.972-13.178-18.402 5.634-31.786 22.746-31.786 42.994v85.754c0 24.832 20.132 44.964 44.964 44.964h842.718c20.248 0 37.358-13.386 42.994-31.786-4.172 1.274-8.594 1.97-13.18 1.97z" fill="rgb(0, 0, 0)" stroke="inherit" stroke-width="inherit" stroke-linejoin="inherit" stroke-linecap="inherit" stroke-miterlimit="inherit" opacity="0.2">
                                                            </path><path className="cursor-pointer " ng-repeat="path in icon.paths track by tempIds[$index]" mi-d="M511.999 850.458c-17.734 0-32.112-14.378-32.112-32.112v-352.279c0-17.734 14.378-32.112 32.112-32.112s32.112 14.378 32.112 32.112v352.277c0 17.738-14.376 32.114-32.112 32.114z" mi-fill="rgb(0, 0, 0)" mi-stroke="inherit" mi-stroke-width="inherit" mi-stroke-linejoin="inherit" mi-stroke-linecap="inherit" mi-stroke-miterlimit="inherit" mi-opacity="0.2" ng-click="selectPath($index)" mi-absorb-clicks="" d="M511.999 850.458c-17.734 0-32.112-14.378-32.112-32.112v-352.279c0-17.734 14.378-32.112 32.112-32.112s32.112 14.378 32.112 32.112v352.277c0 17.738-14.376 32.114-32.112 32.114z" fill="rgb(0, 0, 0)" stroke="inherit" stroke-width="inherit" stroke-linejoin="inherit" stroke-linecap="inherit" stroke-miterlimit="inherit" opacity="0.2">
                                                            </path><path className="cursor-pointer " ng-repeat="path in icon.paths track by tempIds[$index]" mi-d="M320.845 850.46c-15.95 0-29.78-11.872-31.82-28.11l-44.266-352.277c-2.212-17.598 10.26-33.652 27.858-35.864 17.614-2.23 33.652 10.26 35.864 27.858l44.266 352.277c2.212 17.598-10.26 33.652-27.858 35.864-1.362 0.17-2.712 0.252-4.044 0.252z" mi-fill="rgb(0, 0, 0)" mi-stroke="inherit" mi-stroke-width="inherit" mi-stroke-linejoin="inherit" mi-stroke-linecap="inherit" mi-stroke-miterlimit="inherit" mi-opacity="0.2" ng-click="selectPath($index)" mi-absorb-clicks="" d="M320.845 850.46c-15.95 0-29.78-11.872-31.82-28.11l-44.266-352.277c-2.212-17.598 10.26-33.652 27.858-35.864 17.614-2.23 33.652 10.26 35.864 27.858l44.266 352.277c2.212 17.598-10.26 33.652-27.858 35.864-1.362 0.17-2.712 0.252-4.044 0.252z" fill="rgb(0, 0, 0)" stroke="inherit" stroke-width="inherit" stroke-linejoin="inherit" stroke-linecap="inherit" stroke-miterlimit="inherit" opacity="0.2">
                                                            </path><path className="cursor-pointer " ng-repeat="path in icon.paths track by tempIds[$index]" mi-d="M703.155 850.46c-1.334 0-2.684-0.084-4.044-0.254-17.598-2.212-30.070-18.268-27.858-35.864l44.266-352.277c2.212-17.598 18.29-30.068 35.864-27.858 17.598 2.212 30.070 18.268 27.858 35.864l-44.266 352.277c-2.040 16.238-15.87 28.112-31.82 28.112z" mi-fill="rgb(0, 0, 0)" mi-stroke="inherit" mi-stroke-width="inherit" mi-stroke-linejoin="inherit" mi-stroke-linecap="inherit" mi-stroke-miterlimit="inherit" mi-opacity="0.2" ng-click="selectPath($index)" mi-absorb-clicks="" d="M703.155 850.46c-1.334 0-2.684-0.084-4.044-0.254-17.598-2.212-30.070-18.268-27.858-35.864l44.266-352.277c2.212-17.598 18.29-30.068 35.864-27.858 17.598 2.212 30.070 18.268 27.858 35.864l-44.266 352.277c-2.040 16.238-15.87 28.112-31.82 28.112z" fill="rgb(0, 0, 0)" stroke="inherit" stroke-width="inherit" stroke-linejoin="inherit" stroke-linecap="inherit" stroke-miterlimit="inherit" opacity="0.2">
                                                            </path><path className="cursor-pointer " ng-repeat="path in icon.paths track by tempIds[$index]" mi-d="M934 139.778h-196.592v-6.71c-0-73.374-59.694-133.068-133.070-133.068h-184.68c-73.372 0-133.068 59.694-133.068 133.066v6.71h-196.588c-33.294 0-60.378 27.086-60.378 60.378v87.040c0 33.294 27.084 60.378 60.378 60.378h11.928l75.12 596.975c5.7 45.296 44.428 79.452 90.080 79.452h489.745c45.652 0 84.378-34.158 90.080-79.452l75.12-596.975h11.928c33.294 0 60.378-27.086 60.378-60.378v-87.038c-0.002-33.294-27.090-60.378-60.38-60.378zM318.703 133.066c0-55.666 45.288-100.954 100.956-100.954h184.678c55.668 0 100.956 45.288 100.956 100.954v6.71h-33.042v-6.71c0-37.448-30.466-67.914-67.916-67.914h-184.68c-37.448 0-67.916 30.466-67.916 67.914v6.71h-33.042v-6.71h0.006zM640.141 133.066v6.71h-256.287v-6.71c0-19.74 16.062-35.802 35.804-35.802h184.678c19.742 0.002 35.804 16.062 35.804 35.802zM815.090 940.54c-3.684 29.274-28.714 51.35-58.218 51.35h-489.743c-29.504 0-54.536-22.078-58.218-51.35l-74.618-592.969h755.411l-74.614 592.969zM962.266 287.193c0 15.586-12.68 28.266-28.266 28.266h-844c-15.586 0-28.266-12.68-28.266-28.266v-87.038c0-15.586 12.68-28.266 28.266-28.266h844c15.586 0 28.266 12.68 28.266 28.266v87.038zM697.101 866.136c2.002 0.252 4.038 0.382 6.052 0.382 24.204 0 44.732-18.128 47.752-42.164l44.266-352.277c1.606-12.766-1.858-25.392-9.752-35.554s-19.27-16.64-32.032-18.244c-12.77-1.6-25.384 1.858-35.544 9.75-10.166 7.896-16.65 19.272-18.254 32.036l-44.266 352.277c-1.606 12.766 1.858 25.392 9.752 35.554 7.892 10.158 19.268 16.638 32.026 18.24zM687.185 816.346l44.266-352.277c0.536-4.252 2.698-8.046 6.088-10.676 2.848-2.212 6.272-3.38 9.814-3.38 0.672 0 1.352 0.042 2.032 0.126 4.254 0.536 8.048 2.696 10.676 6.082 2.632 3.386 3.788 7.596 3.252 11.852l-44.266 352.277c-1.094 8.69-9.15 15.030-17.934 13.928-4.254-0.536-8.048-2.696-10.676-6.082-2.632-3.388-3.786-7.596-3.252-11.85zM273.093 824.352c3.020 24.036 23.548 42.164 47.752 42.164 2.014 0 4.052-0.128 6.044-0.378 12.768-1.604 24.144-8.082 32.036-18.244 7.89-10.16 11.356-22.788 9.752-35.552l-44.266-352.279c-1.606-12.766-8.080-24.144-18.232-32.036-10.166-7.904-22.806-11.368-35.562-9.75-12.768 1.604-24.144 8.082-32.036 18.244-7.894 10.162-11.356 22.788-9.752 35.552l44.264 352.279zM263.937 456.221c2.63-3.386 6.422-5.546 10.694-6.084 0.682-0.086 1.366-0.128 2.044-0.128 3.536 0 6.954 1.164 9.792 3.372 3.384 2.632 5.544 6.428 6.080 10.688l44.266 352.279c0.536 4.254-0.618 8.462-3.252 11.85-2.632 3.386-6.422 5.546-10.684 6.082-0.672 0.084-1.358 0.128-2.034 0.128-8.054 0-14.882-6.044-15.89-14.056l-44.266-352.279c-0.536-4.258 0.618-8.466 3.25-11.852zM511.999 866.514c26.558 0 48.168-21.606 48.168-48.168v-352.279c0-26.56-21.608-48.168-48.168-48.168s-48.168 21.606-48.168 48.168v352.277c0.002 26.562 21.608 48.17 48.168 48.17zM495.945 466.067c0-8.854 7.202-16.056 16.056-16.056s16.056 7.202 16.056 16.056v352.277c0 8.854-7.202 16.056-16.056 16.056s-16.056-7.202-16.056-16.056v-352.277z" mi-fill="rgb(0, 0, 0)" mi-stroke="inherit" mi-stroke-width="inherit" mi-stroke-linejoin="inherit" mi-stroke-linecap="inherit" mi-stroke-miterlimit="inherit" mi-opacity="1" ng-click="selectPath($index)" mi-absorb-clicks="" d="M934 139.778h-196.592v-6.71c-0-73.374-59.694-133.068-133.070-133.068h-184.68c-73.372 0-133.068 59.694-133.068 133.066v6.71h-196.588c-33.294 0-60.378 27.086-60.378 60.378v87.040c0 33.294 27.084 60.378 60.378 60.378h11.928l75.12 596.975c5.7 45.296 44.428 79.452 90.080 79.452h489.745c45.652 0 84.378-34.158 90.080-79.452l75.12-596.975h11.928c33.294 0 60.378-27.086 60.378-60.378v-87.038c-0.002-33.294-27.090-60.378-60.38-60.378zM318.703 133.066c0-55.666 45.288-100.954 100.956-100.954h184.678c55.668 0 100.956 45.288 100.956 100.954v6.71h-33.042v-6.71c0-37.448-30.466-67.914-67.916-67.914h-184.68c-37.448 0-67.916 30.466-67.916 67.914v6.71h-33.042v-6.71h0.006zM640.141 133.066v6.71h-256.287v-6.71c0-19.74 16.062-35.802 35.804-35.802h184.678c19.742 0.002 35.804 16.062 35.804 35.802zM815.090 940.54c-3.684 29.274-28.714 51.35-58.218 51.35h-489.743c-29.504 0-54.536-22.078-58.218-51.35l-74.618-592.969h755.411l-74.614 592.969zM962.266 287.193c0 15.586-12.68 28.266-28.266 28.266h-844c-15.586 0-28.266-12.68-28.266-28.266v-87.038c0-15.586 12.68-28.266 28.266-28.266h844c15.586 0 28.266 12.68 28.266 28.266v87.038zM697.101 866.136c2.002 0.252 4.038 0.382 6.052 0.382 24.204 0 44.732-18.128 47.752-42.164l44.266-352.277c1.606-12.766-1.858-25.392-9.752-35.554s-19.27-16.64-32.032-18.244c-12.77-1.6-25.384 1.858-35.544 9.75-10.166 7.896-16.65 19.272-18.254 32.036l-44.266 352.277c-1.606 12.766 1.858 25.392 9.752 35.554 7.892 10.158 19.268 16.638 32.026 18.24zM687.185 816.346l44.266-352.277c0.536-4.252 2.698-8.046 6.088-10.676 2.848-2.212 6.272-3.38 9.814-3.38 0.672 0 1.352 0.042 2.032 0.126 4.254 0.536 8.048 2.696 10.676 6.082 2.632 3.386 3.788 7.596 3.252 11.852l-44.266 352.277c-1.094 8.69-9.15 15.030-17.934 13.928-4.254-0.536-8.048-2.696-10.676-6.082-2.632-3.388-3.786-7.596-3.252-11.85zM273.093 824.352c3.020 24.036 23.548 42.164 47.752 42.164 2.014 0 4.052-0.128 6.044-0.378 12.768-1.604 24.144-8.082 32.036-18.244 7.89-10.16 11.356-22.788 9.752-35.552l-44.266-352.279c-1.606-12.766-8.080-24.144-18.232-32.036-10.166-7.904-22.806-11.368-35.562-9.75-12.768 1.604-24.144 8.082-32.036 18.244-7.894 10.162-11.356 22.788-9.752 35.552l44.264 352.279zM263.937 456.221c2.63-3.386 6.422-5.546 10.694-6.084 0.682-0.086 1.366-0.128 2.044-0.128 3.536 0 6.954 1.164 9.792 3.372 3.384 2.632 5.544 6.428 6.080 10.688l44.266 352.279c0.536 4.254-0.618 8.462-3.252 11.85-2.632 3.386-6.422 5.546-10.684 6.082-0.672 0.084-1.358 0.128-2.034 0.128-8.054 0-14.882-6.044-15.89-14.056l-44.266-352.279c-0.536-4.258 0.618-8.466 3.25-11.852zM511.999 866.514c26.558 0 48.168-21.606 48.168-48.168v-352.279c0-26.56-21.608-48.168-48.168-48.168s-48.168 21.606-48.168 48.168v352.277c0.002 26.562 21.608 48.17 48.168 48.17zM495.945 466.067c0-8.854 7.202-16.056 16.056-16.056s16.056 7.202 16.056 16.056v352.277c0 8.854-7.202 16.056-16.056 16.056s-16.056-7.202-16.056-16.056v-352.277z" fill="rgb(0, 0, 0)" stroke="inherit" stroke-width="inherit" stroke-linejoin="inherit" stroke-linecap="inherit" stroke-miterlimit="inherit" opacity="1">
                                                            </path>
                                                        </g>
                                                        <g ng-show="pref.showGrid" className="edit-grid ng-hide">
                                                            <g className="hLines"></g>
                                                            <g className="vLines"></g>
                                                        </g>
                                                    </svg>
                                                </span>
                                            </button>
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    {(itemArray[itemarrindex] !== undefined && itemArray[itemarrindex].serial_number_list.length > 0) ?
                        <button className="btn btn-primary rounded" onClick={() => { setSerialModalShow(false) }}>Done</button>
                        :
                        <button className="btn btn-danger rounded" onClick={() => { setSerialModalShow(false) }}>Close</button>}
                </Modal.Footer>
            </Modal>
            <Organization_modal OrganizationModalShow={OrganizationModalShow} setOrganizationModalShow1={setOrganizationModalShow} organization_name={organization_name} organization_list={organization_list} organization_id={organization_id} state_org={state_org} mainSubmitButtonState={mainSubmitButtonState} setMainSubmitButtonState={setMainSubmitButtonState} />
            <Timer_modal clockTimerModalShow={clockTimerModalShow} setClockTimerModalShow1={setClockTimerModalShow} clock_timer={clock_timer} organization_id={organization_id} timer_ref={timer} mainSubmitButtonState={mainSubmitButtonState} setMainSubmitButtonState={setMainSubmitButtonState} />
        </>
    );
}
export default DealerSaleEntry;